import React, { useEffect, useState } from "react";
import api from "../../lib/api";
import { PageHeader } from "../../components/StaffLayout";
import { Calendar, Bell, Phone } from "@phosphor-icons/react";

export default function Reminders() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/reminders").then((r)=>setData(r.data)); }, []);

  if (!data) return <div className="p-12 text-sm text-zinc-500">Loading...</div>;

  return (
    <div data-testid="reminders-page">
      <PageHeader title="Reminders & Follow-ups" subtitle="The daily action list."/>
      <div className="px-6 sm:px-10 py-8 grid grid-cols-1 lg:grid-cols-2 gap-4">
        <List title="Overdue follow-ups" items={data.overdue_follow_ups} type="lead" accent />
        <List title="Today's follow-ups" items={data.today_follow_ups} type="lead" />
        <List title="Next 7 days Â· follow-ups" items={data.upcoming_follow_ups} type="lead" />
        <List title="Next 7 days Â· appointments" items={data.upcoming_appointments} type="appt" />
      </div>
    </div>
  );
}

function List({ title, items, type, accent }) {
  return (
    <div className="bg-white border border-zinc-200 rounded-sm">
      <div className={`px-5 py-4 border-b border-zinc-200 flex items-center gap-2 ${accent ? "bg-red-50" : ""}`}>
        {accent ? <Bell size={16} weight="duotone" color="#E60000" /> : <Calendar size={16} weight="duotone" />}
        <h3 className="font-bold tracking-tight" style={{fontFamily:"Manrope, sans-serif"}}>{title}</h3>
        <span className="ml-auto text-xs font-bold text-zinc-600">{items?.length || 0}</span>
      </div>
      <div className="divide-y divide-zinc-100">
        {(items || []).length === 0 && <div className="p-6 text-sm text-zinc-500">All clear here.</div>}
        {(items || []).map((it) =>
          type === "lead" ? (
            <div key={it.id} className="px-5 py-3">
              <div className="flex items-center justify-between">
                <div className="font-semibold text-zinc-900">{it.name}</div>
                <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-zinc-600">{it.follow_up_date}</span>
              </div>
              <div className="text-xs text-zinc-500 flex items-center gap-1 mt-0.5">
                <Phone size={12} weight="bold"/> {it.phone} {it.service && ` Â· ${it.service}`}
              </div>
            </div>
          ) : (
            <div key={it.id} className="px-5 py-3">
              <div className="flex items-center justify-between">
                <div className="font-semibold text-zinc-900">Appointment</div>
                <span className="text-[10px] uppercase tracking-[0.2em] font-bold text-zinc-600">{new Date(it.starts_at).toLocaleString()}</span>
              </div>
              <div className="text-xs text-zinc-500 mt-0.5">{it.treatment || "Consultation"} Â· {it.doctor || "â€”"}</div>
            </div>
          )
        )}
      </div>
    </div>
  );
}
